import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: () => import ('@/views/index')
    },
    {
      path: '/channel',
      name: '渠道合作',
      component: () => import ('@/views/channel')
    },
    {
      path: '/inquiry',
      name: '授权认证查询',
      component: () => import ('@/views/inquiry')
    },
    {
      path: '/aboutus',
      name: '关于我们',
      component: () => import ('@/views/aboutUs')
    },
    {
      path: '/product/aifacevip',
      name: 'AI刷脸会员',
      component: () => import ('@/views/product/aifacevip')
    },
    {
      path: '/product/aifacepayment',
      name: 'AI刷脸支付',
      component: () => import ('@/views/product/aifacepayment')
    },
    {
      path: '/product/qingting',
      name: '蜻蜓',
      component: () => import ('@/views/product/qingting')
    },
    {
      path: '/product/cashierTerminal',
      name: '刷脸会员双屏式收银终端',
      component: () => import ('@/views/product/cashierTerminal')
    },
    {
      path: '/product/selfServiceTerminal',
      name: '刷脸支付自助收银终端',
      component: () => import ('@/views/product/selfServiceTerminal')
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js